import { defineStore } from 'pinia';

export const useGlobalStore = defineStore({
  id: 'global',
  state: () => ({
    loaderCount: 0,
    isSupportActive: false,
    termsLink: '',
    policyLink: '',
    applicationData: {
      title: '',
      subtitle: '',
      phones: '',
      text: '',
    },
    applicationPopup: {
      visible: false,
      type: '',
      title: '',
      centerId: '',
      carId: '',
      serviceId: '',
      maintenanceData: {},
      services: [],
    },
    catalogPageTitle: '',
    catalogPageMetaDescription: '',
    googleMapsApiKey: '',
    captchaSiteKey: '',
  }),
  getters: {
    isLoading: (state) => state.loaderCount > 0,
  },
  actions: {
    setCatalogPageTitle(title) {
      this.catalogPageTitle = title;
    },
    setCatalogPageMetaDescription(text) {
      this.catalogPageMetaDescription = text;
    },
    setCarId(value) {
      this.applicationPopup.carId = value;
    },
    setLinks(termsLink, policyLink) {
      this.termsLink = termsLink;
      this.policyLink = policyLink;
    },
    setApplicationData(data) {
      this.applicationData.title = data.title;
      this.applicationData.subtitle = data.subtitle;
      this.applicationData.phones = data.phones;
      this.applicationData.text = data.text;
    },
    setApiKeys(data) {
      this.googleMapsApiKey = data.googleMapsApiKey;
      this.captchaSiteKey = data.captchaSiteKey;
    },
    setApplicationPopup(action) {
      this.applicationPopup.visible = action.visible;
      this.applicationPopup.type = action.type;

      this.applicationPopup.title = action.title || '';
      this.applicationPopup.centerId = action.centerId || '';

      this.applicationPopup.maintenanceData = action.maintenanceData || {};
      this.applicationPopup.services = action.services || [];
    },
    closeApplicationPopup() {
      this.applicationPopup.visible = false;
      this.applicationPopup.type = '';

      this.applicationPopup.title = '';
      this.applicationPopup.centerId = '';
      this.applicationPopup.maintenanceData = {};
      this.applicationPopup.services = [];
    },
    clearApplicationPopup() {
      this.applicationPopup.title = '';
      this.applicationPopup.type = '';
      this.applicationPopup.centerId = '';
      this.applicationPopup.carId = '';
      this.applicationPopup.maintenanceData = {};
      this.applicationPopup.services = [];
    },
    startLoader() {
      this.loaderCount++;
    },
    stopLoader() {
      if (this.loaderCount > 0) this.loaderCount--;
    },
    resetLoader() {
      this.loaderCount = 0;
    },
    async fetchData(val, options = {}) {
      try {
        const res = await useRequest(val, options);
        return res;
      } catch (e) {
        console.error('fetchData failed:', e);
        throw e;
      }
    },
    async fetchPageData(slug, params = {}) {
      if (!slug || /^_+nuxt/i.test(slug) || /^favicon/i.test(slug)) {
        return null;
      }
      try {
        const res = await useRequest(`${slug}`, { query: params });
        return res;
      } catch (e) {
        console.error('fetchPageData failed:', e);
        throw e;
      }
    },
  },
});
